import "react-toastify/dist/ReactToastify.css";

import posthog from "posthog-js";
import { useEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import AuthRoute from "@components/AuthRoute";
import {
    PaymentCallbackBridge
} from "@components/PaymentMethodManager/components/PaymentCallbackBridge";
import StripeContainer from "@components/PaymentMethodManager/components/PaymentForm/StripeContainer";
import PublicRoute from "@components/PublicRoute";
import { AuthProvider } from "@contexts/auth/AuthProvider";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

import { pages } from "./imports";

// Defined once, outside App's render body -- a stable reference for Route's
// component prop, not a new function every render.
const LoadingPage = () => <>Loading...</>;
const NotFoundPage = () => <>Not found</>;
const DashboardWithStripe = () => (
  <StripeContainer>
    <pages.Dashboard />
  </StripeContainer>
);
const CheckoutPageWithStripe = () => (
  <StripeContainer>
    <pages.CheckoutPage />
  </StripeContainer>
);

const App = () => {
  const THEME = createTheme({
    // some elements from material ui can't apply our font.
    typography: {
      fontFamily: "Inter",
    },
  });

  const history = useHistory();

  useEffect(() => {
    // Listen for route changes
    const unlisten = history.listen(() => {
      // Capture the pageview with PostHog on every route change
      posthog.capture("$pageview");
    });

    // Cleanup the listener on component unmount
    return () => {
      unlisten();
    };
  }, [history]);

  return (
    <>
      <ThemeProvider theme={THEME}>
        <ToastContainer />
        <AuthProvider>
          <Switch>
            <PublicRoute path="/registration" component={pages.SignupPage} />
            <PublicRoute exact path="/login" component={pages.LoginPage} />
            <PublicRoute exact path="/security-code/:token" component={pages.SecurityCodePage} />
            <PublicRoute exact path="/forgot-password" component={pages.ForgotPasswordPage} />
            <Route path="/thank_you" component={pages.ThankYou} />
            {/* Start Auth Pages */}
            <AuthRoute path="/" component={LoadingPage} exact />
            <AuthRoute path="/consultation" component={pages.Consultation} />
            <AuthRoute path="/payment-success" component={PaymentCallbackBridge} />
            <AuthRoute path="/dashboard" component={DashboardWithStripe} />
            {/* The rebuilt admin, outside the patient Dashboard. */}
            <AuthRoute path="/admin" component={pages.AdminGate} />
            <AuthRoute path="/checkout" component={CheckoutPageWithStripe} />
            {/* End Auth Pages */}
            <PublicRoute path="*" component={NotFoundPage} />
          </Switch>
        </AuthProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
